import React, { Component } from "react";

export class DocsList extends Component {
  render() {
    let { listTitle } = this.props;
    let { pencilplus,cardIcon,downloadIcon  } = imagepaths;
    return (
      <>
        <li className="list-group-item">
          <div className="list_container">
            <div className="me-3 listTitle">{listTitle || "List"}</div>
            <div className="docs_btn_container">
              <button className="docs_list_btn">
                <img src={cardIcon} />
                <span className="mx-3">PAN Card</span>
                <img src={downloadIcon} />
              </button>
              <button className="docs_list_btn">
                <img src={cardIcon} />
                <span className="mx-3">Aadhar Card</span>
                <img src={downloadIcon} />
              </button>
            </div>
          </div>
        </li>
      </>
    );
  }
}

export default DocsList;
